var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_1990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3303 0.499512L14.7798 0.499512V18.8915C14.7798 21.0829 13.0297 22.883 10.8517 22.883C8.67367 22.883 6.9235 21.0829 6.9235 18.8915C6.9235 16.7393 8.63478 14.9783 10.735 14.9001V10.2825C6.10675 10.3607 2.37305 14.1566 2.37305 18.8915C2.37305 23.6657 6.18453 27.5006 10.8906 27.5006C15.5966 27.5006 19.408 23.6265 19.408 18.8915V9.46071C21.1193 10.713 23.2195 11.4565 25.4364 11.4956V6.87802C22.0139 6.76063 19.3303 3.94312 19.3303 0.499512Z",
    fill: "#131316"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_1990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.0011,
    height: 27.0011,
    fill: "white",
    transform: "translate(0.123047 0.499512)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.63cc6e9ae9e3d85e57c4c8d32943c420.svg";
export { ForwardRef as ReactComponent };